import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
export function NewsSection() {
  const news = [{
    image: 'https://images.unsplash.com/photo-1544531586-fde5298cdd40?w=800&q=80',
    date: 'October 15, 2023',
    title: 'New Regulatory Framework Proposed',
    excerpt: 'FGSU participates in the parliamentary hearing regarding the new amendments to the gambling law, advocating for stricter player protection measures.'
  }, {
    image: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800&q=80',
    date: 'September 28, 2023',
    title: 'Partnership with International Responsible Gaming Council',
    excerpt: 'We are proud to announce our official partnership with the IRGC to bring global best practices to the Ukrainian market.'
  }, {
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80',
    date: 'August 10, 2023',
    title: 'Launch of 24/7 Support Helpline',
    excerpt: 'Our new dedicated helpline for players and families is now active, providing free and confidential psychological support.'
  }];
  return <section id="news" className="py-20 bg-gray-50" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <SectionHeading title="Latest News" subtitle="Updates on our initiatives and industry developments." data-id="element-166" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-167">
          {news.map((item, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-168">
              <div className="h-48 overflow-hidden" data-id="element-169">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-170" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-171">
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-172">
                  <Calendar size={14} className="mr-2" data-id="element-173" />
                  {item.date}
                </div>
                <h3 className="text-xl font-serif font-bold text-gray-900 mb-3 line-clamp-2" data-id="element-174">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-1 line-clamp-3" data-id="element-175">
                  {item.excerpt}
                </p>
                <a href="#" className="inline-flex items-center text-[#0f5f5f] font-semibold hover:text-[#d4a74a] transition-colors mt-auto" data-id="element-176">
                  Read More <ArrowRight size={16} className="ml-2" data-id="element-177" />
                </a>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}